"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FortmaticConnector = void 0;

var fortmatic_connector_1 = require("@web3-react/fortmatic-connector");

var configuration_1 = require("../configuration");

var types_1 = require("../types");

var FortmaticConnector = /*#__PURE__*/function (_fortmatic_connector_) {
  _inherits(FortmaticConnector, _fortmatic_connector_);

  function FortmaticConnector(chainId) {
    var _this;

    _classCallCheck(this, FortmaticConnector);

    var apiKeys = configuration_1.getConfiguration()[types_1.ProviderType.FORTMATIC].apiKeys;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FortmaticConnector).call(this, {
      chainId: chainId,
      apiKey: apiKeys[chainId]
    }));
    _this.apiKeys = apiKeys;
    return _this;
  }

  _createClass(FortmaticConnector, [{
    key: "getApiKey",
    value: function getApiKey() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var chainId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getChainId();

              case 2:
                chainId = _context.sent;
                return _context.abrupt("return", this.apiKeys[chainId]);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return FortmaticConnector;
}(fortmatic_connector_1.FortmaticConnector);

exports.FortmaticConnector = FortmaticConnector;